import { ref } from '@vue/runtime-dom'

export const getTableConfig = () => {
  // table 通用属性
  const common = {
    // table 有多选时设置
    isSelection: false,
    // table loading
    loading: false,
    // table 是否为斑马纹
    stripe: true,
    // table 的尺寸 medium / small / mini
    size: 'small',
    // table 是否开启索引
    isIndex: true,
    // // table 索引 label
    indexLabel: '序号',
    // table 数据
    data: []
  }

  // table 分页
  const pagination = {
    // 是否展示分页
    isShow: true,
    // 总条数
    total: 0,
    // 每页显示条目个数
    pageSize: 20,
    // 当前页数
    currentPage: 1,
    // 每页显示个数选择器的选项设置
    pageSizes: [10, 20, 40, 80, 100]
  }

  // table 列数据
  const column = [
    {
      key: 'companyName',
      label: '企业名称',
      width: '140'
    },
    {
      key: 'orgCertCode',
      label: '单位证书编号',
      width: '140'
    },
    {
      key: 'orgName',
      label: '资产公司',
      width: '140'
    },
    {
      key: 'hostLocation',
      label: '域名',
      width: '160'
    },
    {
      key: 'api',
      label: '接口地址',
      width: '160'
    },
    {
      key: 'param',
      label: '请求参数',
      width: '160'
    },
    {
      key: 'content',
      label: '错误信息',
      width: '140'
    },
    {
      key: 'createTime',
      label: '创建时间',
      width: '160'
    },
    {
      key: 'action',
      label: '操作',
      width: '110',
      fixed: 'right',
      slot: 'action'
    }

  ]

  return {
    ...common,
    pagination,
    column
  }
}

// 搜索配置
export const inputList = (remoteData1: any, remoteData2: any) => [
  {
    type: 'datePicker',
    label: '操作时间',
    key: 'Time',
    placeholder: '请选择',
    labelWidth: 100,
    inputWidth: 410,
    format: 'YYYY-MM-DD HH:mm',
    // 操作时间默认当天 0 点 ~ 次日 0 点
    value: [new Date(new Date().setHours(0, 0, 0, 0)), new Date(new Date().setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000)],
    // 设置禁用状态，参数为当前日期，要求返回 Boolean
    // disabledDate: (time) => {
    //   return time.getTime() > Date.now()
    // },
    // 日期类型 year/month/date/dates/ week/datetime/datetimerange/ daterange/monthrange
    dateType: 'datetimerange',
    formatList: ['YYYY-MM-DD HH:mm:00', 'YYYY-MM-DD HH:mm:00'], // 开始，结束时间格式
    keyList: ['createTimeStart', 'createTimeEnd'], // 开始，结束时间字段
    // 开启日期范围后生效
    unlinkPanels: false,
    rangeSeparator: '-',
    startPlaceholder: '开始日期',
    endPlaceholder: '结束日期',
    rules: {
      // 默认 date 开启范围 array
      required: true,
      message: '必填',
      type: 'array'
    }
  },
  {
    type: 'select',
    label: '企业名称',
    key: 'companyUuid',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 340,
    maxlength: 8,
    options: remoteData2.options,
    isLoading: remoteData2.isLoading,
    isRemote: true,
    isMultiple: false,
    isFilterable: true,
    isCollapseTags: false,
    remoteMethod: remoteData2.remoteMethod,
    rules: {
    }
  },
  {
    type: 'select',
    label: '资产公司',
    key: 'orgCertCode',
    placeholder: '请输入',
    labelWidth: 100,
    inputWidth: 200,
    maxlength: 50,
    options: remoteData1.options,
    isLoading: remoteData1.isLoading,
    isRemote: true,
    isMultiple: false,
    isFilterable: true,
    isCollapseTags: false,
    remoteMethod: remoteData1.remoteMethod,
    rules: {
    }
  },

  {
    type: 'input',
    label: '域名',
    key: 'hostLocation',
    placeholder: '请输入',
    labelWidth: 110,
    inputWidth: 200
  },
  {
    type: 'input',
    label: '接口地址',
    key: 'api',
    placeholder: '请输入',
    labelWidth: 110,
    inputWidth: 200
  },
  {
    type: 'input',
    label: '请求参数',
    key: 'param',
    placeholder: '请输入',
    labelWidth: 110,
    inputWidth: 200
  },

]

// 页面搜索和基础变量
export const getIndexConfig = () => {
  // 页面基础变量
  const page = {
    queryForm: ref<any>({

    }), // 搜索参数
    visible: false,
    rowData: null,
    determine: false,
    title: ''
  }
  return {
    ...page
  }
}
